import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';
import { RotationDashboard, RotationDashboardParams, PageMode } from './model';
import { RotationDashboardView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { NavbarTab } from 'portcall/navbar/view';

export function RotationDashboardRoute(
    model : (params : RotationDashboardParams) => RotationDashboard,
    appWrapper : AppWrapper,
    request : Location
) : IRoute {
    const m = model(inboundParams(request));
    return {
        view:
            <AppWrapperView model={appWrapper} navbarTab={NavbarTab.Pilots}>
                <RotationDashboardView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
}

function inboundParams(request : Location) : RotationDashboardParams {
    return {
        id: +(request.params['id'] || 0),
        mode: request.params['mode'] ? +request.params['mode']! : PageMode.View
    };
}

function outboundParams(request : Location, m : RotationDashboard) {
    const params = {} as LocationParams;
    params['id'] = '' + m.Model.Id();
    if (m.PageMode() !== PageMode.View) params['mode'] = '' + m.PageMode();
    return new Location(request.name, params);
}


// WEBPACK FOOTER //
// ./apps/pilots/rotationdashboard/route.tsx